export default {
    "title": "Existencias / {{client}}",
    "description": "Ficheros de existencias con descarga en formato PDF",
    "last": {
        "recent": "Fichero de existencias más reciente disponible",
        "date": "Fecha y hora:"
    },
    "downloadButton": "Descargar",
    "stocksTableHeader": "<0>{{count}}</0> ficheros de existencias anteriores disponibles",
    "stocksTableColumns": {
        "date": "Fecha y hora",
        "download": "Descargar existencias"
    },
    "nameCollection": "existencias",
    "download": {
        "pdf": "Descarga en PDF",
        "xls": "Descarga en XLSX",
        "json": "Descarga en JSON",
    }
}